import { render, staticRenderFns } from "./HistoryBloodOxygen.vue?vue&type=template&id=1be9e386&scoped=true"
import script from "./HistoryBloodOxygen.vue?vue&type=script&lang=js"
export * from "./HistoryBloodOxygen.vue?vue&type=script&lang=js"
import style0 from "./HistoryBloodOxygen.vue?vue&type=style&index=0&id=1be9e386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9e386",
  null
  
)

export default component.exports